import kebabCase from 'lodash/kebabCase'

const slugFromResultTitle = (title: string | null | undefined) => {
  return kebabCase(`Save on ${title || 'this product'}`)
}

export default slugFromResultTitle
